// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "ReportDetailTemplate-module--hgwIcon-arrow-down--1Kac-";
export var hgwIconArrowUp = "ReportDetailTemplate-module--hgwIcon-arrow-up--XWzoo";
export var lSingleBody = "ReportDetailTemplate-module--l-singleBody--3HlxD";
export var lSingleBody__main = "ReportDetailTemplate-module--l-singleBody__main--2cloq";
export var lSingleBody__main__zoomControl = "ReportDetailTemplate-module--l-singleBody__main__zoomControl--2kV8q";
export var lSingleBody__nav = "ReportDetailTemplate-module--l-singleBody__nav--3pSKb";
export var invisible = "ReportDetailTemplate-module--invisible--1RF5p";
export var docMeta = "ReportDetailTemplate-module--docMeta--35bv0";
export var docMeta__title = "ReportDetailTemplate-module--docMeta__title--1RTLy";
export var docMeta__sub = "ReportDetailTemplate-module--docMeta__sub--2h6yT";
export var docMeta__pageNum = "ReportDetailTemplate-module--docMeta__pageNum--3s7lV";
export var lQandA = "ReportDetailTemplate-module--lQandA--lOCPv";
export var lPages = "ReportDetailTemplate-module--lPages--2ERxF";
export var lPages__page = "ReportDetailTemplate-module--lPages__page--6bIg3";
export var showNavigatorButton = "ReportDetailTemplate-module--showNavigatorButton--3t14G";
export var notes = "ReportDetailTemplate-module--notes--2xwjb";
export var profile = "ReportDetailTemplate-module--profile--1_vp1";
export var colorRed = "ReportDetailTemplate-module--colorRed--1IviI";
export var animBarTypeA = "ReportDetailTemplate-module--animBarTypeA--1_Ci_";
export var animBarTypeB = "ReportDetailTemplate-module--animBarTypeB--Twhh9";
export var animBarTypeC = "ReportDetailTemplate-module--animBarTypeC--2Z7uG";
export var animBarTypeD = "ReportDetailTemplate-module--animBarTypeD--2pAAY";